module.exports = __webpack_public_path__ + "static/img/cpzx-rP_JuD7r.f2f589c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/cpzx-rP_JuD7r.png
// module id = FbL0
// module chunks = 16